import { useState, useEffect, useRef } from "react";

const slides = [
  // USA Factory & Farm Products (15)
  {
    id: 1,
    tag: "🇺🇸 USA Factory Direct",
    headline: "Premium American Hardwood Furniture",
    sub: "Solid oak & walnut pieces crafted in Tennessee factories. Direct from maker to your door.",
    cta1: "Shop Furniture",
    cta1Href: "#overseas-warehouse",
    cta2: "View Suppliers",
    cta2Href: "#suppliers",
    bg: "https://public.readdy.ai/ai/img_res/79cfd1682ac49d336e2dca88cefc3c49.jpg",
    accent: "#D4AF37",
  },
  {
    id: 2,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "Organic Honey From American Beehives",
    sub: "Raw wildflower honey harvested from pristine Montana and Idaho farms. Pure, unfiltered, certified organic.",
    cta1: "Order Honey",
    cta1Href: "#overseas-warehouse",
    cta2: "Meet Farmers",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20golden%20honey%20dripping%20from%20honeycomb%20on%20a%20beautiful%20American%20farm%2C%20beekeeper%20in%20white%20suit%2C%20wildflower%20meadow%20background%2C%20warm%20golden%20sunlight%2C%20jars%20of%20amber%20honey%20glowing%20in%20sunlight%2C%20lush%20green%20Montana%20landscape%2C%20rich%20golden%20tones&width=1400&height=680&seq=hero_usa2&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 3,
    tag: "🇺🇸 USA Factory Direct",
    headline: "American-Made Steel Tools & Equipment",
    sub: "Heavy-duty hand tools forged in Ohio and Pennsylvania. Built to last a lifetime, backed by USA craftsmanship.",
    cta1: "Shop Tools",
    cta1Href: "#overseas-warehouse",
    cta2: "Browse Factory",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=gleaming%20American%20steel%20hand%20tools%20arranged%20beautifully%20on%20a%20workshop%20bench%2C%20sparks%20flying%20from%20a%20forge%20in%20background%2C%20dramatic%20industrial%20lighting%2C%20premium%20quality%20wrenches%20hammers%20and%20pliers%2C%20warm%20golden%20factory%20glow%2C%20USA%20manufacturing%20excellence&width=1400&height=680&seq=hero_usa3&orientation=landscape",
    accent: "#C41E3A",
  },
  {
    id: 4,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "California Almond & Nut Farms",
    sub: "Sun-ripened almonds, walnuts and pistachios straight from California's Central Valley. Bulk wholesale pricing.",
    cta1: "Buy Wholesale",
    cta1Href: "#overseas-warehouse",
    cta2: "Farm Details",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=breathtaking%20California%20almond%20orchard%20in%20full%20bloom%2C%20rows%20of%20almond%20trees%20with%20white%20blossoms%2C%20golden%20afternoon%20sunlight%2C%20beautiful%20farm%20landscape%2C%20fresh%20almonds%20in%20wooden%20crates%2C%20warm%20golden%20California%20sunshine%2C%20stunning%20agricultural%20scenery&width=1400&height=680&seq=hero_usa4&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 5,
    tag: "🇺🇸 USA Factory Direct",
    headline: "Handcrafted American Leather Goods",
    sub: "Full-grain leather wallets, belts and bags made in Texas. Each piece individually crafted by skilled artisans.",
    cta1: "Shop Leather",
    cta1Href: "#overseas-warehouse",
    cta2: "View Artisans",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=luxurious%20full%20grain%20leather%20goods%20beautifully%20arranged%2C%20Texas%20leather%20workshop%20with%20skilled%20artisan%20stitching%20a%20wallet%2C%20rich%20brown%20leather%20textures%2C%20warm%20amber%20workshop%20lighting%2C%20premium%20handcrafted%20quality%2C%20beautiful%20leather%20bags%20and%20accessories&width=1400&height=680&seq=hero_usa5&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 6,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "Pacific Northwest Wild-Caught Salmon",
    sub: "Fresh-frozen wild Alaskan salmon and Pacific seafood. Sustainably caught, flash-frozen at sea for peak freshness.",
    cta1: "Order Seafood",
    cta1Href: "#overseas-warehouse",
    cta2: "Learn More",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20wild%20caught%20Alaskan%20salmon%20on%20ice%20at%20a%20Pacific%20Northwest%20fishing%20dock%2C%20beautiful%20red%20pink%20salmon%20flesh%2C%20fishing%20boats%20in%20background%2C%20dramatic%20ocean%20sunset%2C%20fresh%20seafood%20market%20display%2C%20golden%20hour%20light%20on%20water%2C%20pristine%20Alaskan%20wilderness&width=1400&height=680&seq=hero_usa6&orientation=landscape",
    accent: "#C41E3A",
  },
  {
    id: 7,
    tag: "🇺🇸 USA Factory Direct",
    headline: "American Ceramic & Pottery Studio",
    sub: "Handthrown stoneware and porcelain from North Carolina studios. Each piece unique, food-safe, dishwasher safe.",
    cta1: "Shop Ceramics",
    cta1Href: "#overseas-warehouse",
    cta2: "Meet Artists",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=beautiful%20handcrafted%20ceramic%20pottery%20on%20a%20wooden%20table%2C%20potter%20hands%20shaping%20clay%20on%20wheel%20in%20North%20Carolina%20studio%2C%20warm%20earthy%20tones%2C%20stunning%20glazed%20bowls%20and%20mugs%2C%20golden%20studio%20lighting%2C%20artisan%20craftsmanship%2C%20rustic%20elegant%20aesthetic&width=1400&height=680&seq=hero_usa7&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 8,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "Texas Grass-Fed Beef & Wagyu",
    sub: "Premium grass-fed Angus and Wagyu beef from Texas ranches. USDA certified, no hormones, no antibiotics.",
    cta1: "Order Beef",
    cta1Href: "#overseas-warehouse",
    cta2: "Ranch Details",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20Texas%20cattle%20ranch%20at%20golden%20hour%2C%20beautiful%20Angus%20cattle%20grazing%20on%20lush%20green%20pasture%2C%20dramatic%20Texas%20sky%20with%20golden%20clouds%2C%20premium%20wagyu%20beef%20cuts%20beautifully%20presented%20on%20wooden%20board%2C%20rich%20marbling%20visible%2C%20warm%20golden%20sunset%20light&width=1400&height=680&seq=hero_usa8&orientation=landscape",
    accent: "#C41E3A",
  },
  {
    id: 9,
    tag: "🇺🇸 USA Factory Direct",
    headline: "Vermont Maple Syrup & Artisan Foods",
    sub: "Pure Grade A maple syrup tapped from Vermont sugar maples. Family farms producing since 1890.",
    cta1: "Shop Maple",
    cta1Href: "#overseas-warehouse",
    cta2: "Farm Story",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=gorgeous%20Vermont%20maple%20syrup%20farm%20in%20autumn%2C%20sugar%20maple%20trees%20with%20brilliant%20red%20orange%20gold%20foliage%2C%20maple%20syrup%20being%20poured%20from%20a%20beautiful%20glass%20bottle%2C%20golden%20amber%20syrup%20glowing%20in%20sunlight%2C%20rustic%20Vermont%20farm%20house%2C%20stunning%20fall%20colors&width=1400&height=680&seq=hero_usa9&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 10,
    tag: "🇺🇸 USA Factory Direct",
    headline: "American Glass & Crystal Artworks",
    sub: "Hand-blown glass art and crystal from Washington State studios. Museum-quality pieces for home and gifting.",
    cta1: "Shop Glass Art",
    cta1Href: "#overseas-warehouse",
    cta2: "View Studio",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20hand%20blown%20glass%20art%20pieces%20glowing%20with%20vibrant%20colors%2C%20glass%20blower%20at%20work%20in%20Washington%20State%20studio%2C%20molten%20glass%20glowing%20orange%20and%20gold%2C%20beautiful%20crystal%20vases%20and%20sculptures%2C%20dramatic%20studio%20lighting%2C%20artistic%20masterpieces&width=1400&height=680&seq=hero_usa10&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 11,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "Florida Citrus & Tropical Fruits",
    sub: "Sun-kissed Florida oranges, grapefruits and tropical fruits. Picked at peak ripeness, shipped same day.",
    cta1: "Order Citrus",
    cta1Href: "#overseas-warehouse",
    cta2: "Grove Tour",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=beautiful%20Florida%20citrus%20grove%20with%20ripe%20golden%20oranges%20and%20grapefruits%20hanging%20from%20trees%2C%20warm%20Florida%20sunshine%2C%20vibrant%20orange%20and%20yellow%20fruits%2C%20lush%20green%20grove%2C%20fresh%20citrus%20in%20wooden%20crates%2C%20stunning%20tropical%20landscape%2C%20golden%20morning%20light&width=1400&height=680&seq=hero_usa11&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 12,
    tag: "🇺🇸 USA Factory Direct",
    headline: "Colorado Outdoor & Camping Gear",
    sub: "Rugged tents, sleeping bags and hiking gear made in Colorado. Tested in the Rockies, built for any adventure.",
    cta1: "Shop Gear",
    cta1Href: "#overseas-warehouse",
    cta2: "See Products",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20Colorado%20Rocky%20Mountain%20campsite%20at%20golden%20hour%2C%20premium%20camping%20tent%20set%20up%20with%20mountain%20peaks%20in%20background%2C%20beautiful%20outdoor%20gear%20laid%20out%2C%20dramatic%20golden%20sunset%20sky%2C%20adventure%20lifestyle%2C%20pristine%20wilderness%2C%20warm%20golden%20light%20on%20mountains&width=1400&height=680&seq=hero_usa12&orientation=landscape",
    accent: "#C41E3A",
  },
  {
    id: 13,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "Pacific Northwest Organic Coffee",
    sub: "Small-batch roasted coffee from Oregon and Washington roasters. Single-origin beans, ethically sourced.",
    cta1: "Shop Coffee",
    cta1Href: "#overseas-warehouse",
    cta2: "Roaster Story",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=beautiful%20artisan%20coffee%20roastery%20in%20Oregon%2C%20freshly%20roasted%20coffee%20beans%20glowing%20warm%20brown%2C%20barista%20pouring%20perfect%20latte%20art%2C%20steam%20rising%20from%20coffee%20cup%2C%20warm%20golden%20cafe%20lighting%2C%20premium%20coffee%20bags%2C%20cozy%20Pacific%20Northwest%20aesthetic&width=1400&height=680&seq=hero_usa13&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 14,
    tag: "🇺🇸 USA Factory Direct",
    headline: "American Candle & Fragrance Studio",
    sub: "Hand-poured soy wax candles from Kentucky artisans. Natural fragrances, cotton wicks, beautiful packaging.",
    cta1: "Shop Candles",
    cta1Href: "#overseas-warehouse",
    cta2: "View Studio",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=gorgeous%20artisan%20candle%20studio%20with%20rows%20of%20beautiful%20glowing%20candles%2C%20warm%20golden%20candlelight%2C%20Kentucky%20workshop%20with%20hand%20pouring%20soy%20wax%2C%20elegant%20candle%20jars%20with%20beautiful%20labels%2C%20warm%20amber%20glow%2C%20luxurious%20home%20fragrance%20products%2C%20cozy%20aesthetic&width=1400&height=680&seq=hero_usa14&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 15,
    tag: "🇺🇸 USA Farm Fresh",
    headline: "Georgia Peach & Berry Farms",
    sub: "Juicy Georgia peaches, blueberries and strawberries. Picked at sunrise, shipped fresh to your door.",
    cta1: "Order Fruits",
    cta1Href: "#overseas-warehouse",
    cta2: "Farm Visit",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20Georgia%20peach%20orchard%20at%20sunrise%2C%20beautiful%20ripe%20golden%20peaches%20hanging%20from%20trees%2C%20warm%20pink%20and%20golden%20sunrise%20sky%2C%20fresh%20peaches%20in%20rustic%20wooden%20baskets%2C%20lush%20green%20farm%20landscape%2C%20dew%20drops%20on%20fruit%2C%20gorgeous%20Southern%20farm%20scenery&width=1400&height=680&seq=hero_usa15&orientation=landscape",
    accent: "#D4AF37",
  },
  // Canada Factory Products (3)
  {
    id: 16,
    tag: "🇨🇦 Canada Factory Direct",
    headline: "Canadian Maple Wood Furniture",
    sub: "Heirloom-quality maple and birch furniture from Quebec craftsmen. Sustainably harvested Canadian hardwood.",
    cta1: "Shop Furniture",
    cta1Href: "#canada-overseas-warehouse",
    cta2: "View Makers",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=stunning%20Canadian%20maple%20wood%20furniture%20workshop%20in%20Quebec%2C%20beautiful%20light%20maple%20dining%20table%20and%20chairs%2C%20craftsman%20finishing%20wood%20with%20warm%20golden%20light%2C%20Canadian%20forest%20visible%20through%20workshop%20window%2C%20premium%20hardwood%20grain%2C%20elegant%20Scandinavian%20inspired%20design&width=1400&height=680&seq=hero_canada1&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 17,
    tag: "🇨🇦 Canada Factory Direct",
    headline: "Premium Canadian Winter Apparel",
    sub: "Goose-down parkas and merino wool outerwear from Toronto and Vancouver factories. Rated to -40°C.",
    cta1: "Shop Apparel",
    cta1Href: "#canada-overseas-warehouse",
    cta2: "Factory Tour",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=beautiful%20premium%20Canadian%20winter%20parka%20jacket%20in%20deep%20forest%20green%2C%20snowy%20Canadian%20Rockies%20mountain%20backdrop%2C%20model%20wearing%20luxurious%20goose%20down%20coat%2C%20golden%20winter%20sunlight%20on%20snow%2C%20Vancouver%20mountain%20scenery%2C%20high%20fashion%20outdoor%20apparel%2C%20stunning%20winter%20landscape&width=1400&height=680&seq=hero_canada2&orientation=landscape",
    accent: "#C41E3A",
  },
  {
    id: 18,
    tag: "🇨🇦 Canada Farm Fresh",
    headline: "Canadian Wild Blueberry & Honey",
    sub: "Wild Nova Scotia blueberries and pure Canadian clover honey. Certified organic, no additives, pure nature.",
    cta1: "Order Now",
    cta1Href: "#canada-overseas-warehouse",
    cta2: "Farm Details",
    cta2Href: "#suppliers",
    bg: "https://readdy.ai/api/search-image?query=gorgeous%20Nova%20Scotia%20wild%20blueberry%20farm%2C%20beautiful%20purple%20blue%20blueberries%20on%20bushes%2C%20golden%20Canadian%20honey%20in%20glass%20jars%2C%20warm%20summer%20sunlight%2C%20lush%20green%20Canadian%20countryside%2C%20fresh%20organic%20produce%2C%20stunning%20Maritime%20landscape%2C%20golden%20afternoon%20light&width=1400&height=680&seq=hero_canada3&orientation=landscape",
    accent: "#D4AF37",
  },
  // Warehouse Photos (2)
  {
    id: 19,
    tag: "🇺🇸 USA Local Warehouse",
    headline: "6 USA Warehouses — 1-5 Day Delivery",
    sub: "Los Angeles · New York · Chicago · Dallas · Miami · Seattle. Overseas suppliers stock here, you buy local.",
    cta1: "Shop USA Warehouse",
    cta1Href: "#overseas-warehouse",
    cta2: "Become a Supplier",
    cta2Href: "#overseas-warehouse",
    bg: "https://readdy.ai/api/search-image?query=massive%20modern%20USA%20distribution%20warehouse%20interior%2C%20towering%20shelves%20stacked%20with%20products%2C%20workers%20with%20electric%20forklifts%2C%20dramatic%20golden%20overhead%20lighting%20illuminating%20long%20aisles%2C%20American%20flag%20on%20wall%2C%20state%20of%20the%20art%20logistics%20facility%2C%20impressive%20scale%2C%20warm%20golden%20industrial%20light&width=1400&height=680&seq=hero_warehouse_usa&orientation=landscape",
    accent: "#D4AF37",
  },
  {
    id: 20,
    tag: "🇨🇦 Canada Local Warehouse",
    headline: "6 Canada Warehouses — Fast Delivery",
    sub: "Toronto · Vancouver · Montreal · Calgary · Ottawa · Edmonton. Buy local, ship fast, no import duties.",
    cta1: "Shop Canada Warehouse",
    cta1Href: "#canada-overseas-warehouse",
    cta2: "List Your Products",
    cta2Href: "#canada-overseas-warehouse",
    bg: "https://readdy.ai/api/search-image?query=stunning%20modern%20Canadian%20warehouse%20distribution%20center%20exterior%20at%20golden%20hour%2C%20large%20building%20with%20Canadian%20flag%2C%20trucks%20loading%20at%20docks%2C%20beautiful%20sunset%20sky%20with%20golden%20clouds%2C%20professional%20logistics%20facility%2C%20Toronto%20skyline%20in%20background%2C%20warm%20golden%20evening%20light&width=1400&height=680&seq=hero_warehouse_canada&orientation=landscape",
    accent: "#C41E3A",
  },
];

const badges = [
  { icon: "ri-shield-check-line", label: "Verified Suppliers" },
  { icon: "ri-secure-payment-line", label: "Secure USD & CAD Payment" },
  { icon: "ri-truck-line", label: "Fast USA & Canada Shipping" },
  { icon: "ri-customer-service-2-line", label: "24/7 Support" },
];

const SLIDE_INTERVAL = 4000;

const HeroBanner = () => {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const goTo = (idx: number) => {
    if (animating) return;
    setAnimating(true);
    setCurrent(idx);
    setTimeout(() => setAnimating(false), 600);
  };

  const next = () => goTo((current + 1) % slides.length);
  const prev = () => goTo((current - 1 + slides.length) % slides.length);

  useEffect(() => {
    timerRef.current = setInterval(next, SLIDE_INTERVAL);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [current]);

  const slide = slides[current];

  return (
    <section className="relative w-full overflow-hidden" style={{ background: "linear-gradient(135deg, #b8860b 0%, #D4AF37 40%, #f5d060 70%, #D4AF37 100%)" }}>
      {/* Gold background always visible */}
      <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, #7a5c00 0%, #D4AF37 35%, #f5d060 65%, #c9a227 100%)" }} />

      {/* Slide image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-700"
        style={{
          backgroundImage: `url(${slide.bg})`,
          opacity: animating ? 0 : 1,
        }}
      />
      {/* Gold-tinted dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-[#7a5c00]/30" />
      {/* Gold shimmer top bar */}
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: "linear-gradient(90deg, #D4AF37, #f5d060, #D4AF37)" }} />

      {/* Main content */}
      <div className="relative z-10 h-[520px] md:h-[640px] flex flex-col justify-center max-w-[1400px] mx-auto px-6 md:px-14">
        <div className="max-w-2xl">
          {/* Tag */}
          <div
            className="inline-flex items-center gap-2 border text-xs font-bold px-4 py-1.5 rounded-full mb-5 backdrop-blur-sm"
            style={{ background: "rgba(212,175,55,0.18)", borderColor: "rgba(212,175,55,0.6)", color: "#f5d060" }}
          >
            <i className="ri-vip-crown-line"></i>
            <span>{slide.tag}</span>
          </div>

          {/* Headline */}
          <h1
            className="text-4xl md:text-6xl font-extrabold leading-tight mb-5"
            style={{ color: "#fff", textShadow: "0 2px 20px rgba(0,0,0,0.5)" }}
          >
            {slide.headline}
          </h1>

          {/* Sub */}
          <p className="text-gray-100 text-base md:text-lg mb-8 leading-relaxed max-w-xl" style={{ textShadow: "0 1px 8px rgba(0,0,0,0.4)" }}>
            {slide.sub}
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3">
            <a
              href={slide.cta1Href}
              className="font-bold px-7 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm hover:scale-105"
              style={{ background: "linear-gradient(135deg, #D4AF37, #f5d060)", color: "#1a0a00" }}
            >
              {slide.cta1}
            </a>
            <a
              href={slide.cta2Href}
              className="border-2 font-bold px-7 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap text-sm hover:scale-105"
              style={{ borderColor: "#D4AF37", color: "#f5d060", background: "rgba(212,175,55,0.1)" }}
            >
              {slide.cta2}
            </a>
          </div>
        </div>
      </div>

      {/* Slide counter */}
      <div className="absolute top-6 right-8 z-20 hidden md:flex items-center gap-2">
        <span className="text-[#f5d060] font-bold text-sm">{String(current + 1).padStart(2, "0")}</span>
        <span className="text-white/40 text-xs">/ {String(slides.length).padStart(2, "0")}</span>
      </div>

      {/* Prev / Next arrows */}
      <button
        onClick={prev}
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white hover:bg-white/20 transition-all cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white hover:bg-white/20 transition-all cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      {/* Thumbnail strip */}
      <div className="absolute bottom-14 left-0 right-0 z-20 overflow-x-auto scrollbar-hide">
        <div className="flex gap-2 px-6 md:px-14 w-max mx-auto">
          {slides.map((s, i) => (
            <button
              key={s.id}
              onClick={() => goTo(i)}
              className={`flex-shrink-0 w-14 h-10 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                i === current ? "border-[#D4AF37] scale-110" : "border-white/20 opacity-60 hover:opacity-90"
              }`}
              style={{ backgroundImage: `url(${s.bg})`, backgroundSize: "cover", backgroundPosition: "center" }}
            />
          ))}
        </div>
      </div>

      {/* Badges Bar */}
      <div className="absolute bottom-0 left-0 right-0 z-10" style={{ background: "linear-gradient(90deg, #7a5c00, #b8860b, #7a5c00)" }}>
        <div className="max-w-[1400px] mx-auto px-6 py-3 flex flex-wrap justify-center md:justify-between gap-4">
          {badges.map((b) => (
            <div key={b.label} className="flex items-center gap-2 text-xs font-semibold whitespace-nowrap" style={{ color: "#f5d060" }}>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${b.icon} text-white`}></i>
              </div>
              {b.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
